import { render, staticRenderFns } from "./Masklayer.vue?vue&type=template&id=dbdc6caa&scoped=true"
import script from "./Masklayer.vue?vue&type=script&lang=js"
export * from "./Masklayer.vue?vue&type=script&lang=js"
import style0 from "./Masklayer.vue?vue&type=style&index=0&id=dbdc6caa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbdc6caa",
  null
  
)

export default component.exports